import {
	SESSION_END_REASON_PARAM,
	SessionEndReason,
} from '@dealstack/shared/lib/common/session/sessionContract';

export const returnTargetOf = (location: Pick<Location, 'pathname' | 'search' | 'hash'>): string =>
	`${location.pathname}${location.search}${location.hash}`;

export const currentReturnTarget = (): string => returnTargetOf(window.location);

export const buildLoginPageUrl = (
	redirectUrl?: string,
	sessionEndReason?: SessionEndReason | null
): string => {
	const params = new URLSearchParams();
	if (redirectUrl) {
		params.set('redirectUrl', redirectUrl);
	}
	// SIGNED_OUT is declared by the logout path so a request that 401s on the way out
	// cannot label a deliberate sign-out as involuntary. It explains nothing to the user,
	// so it stays out of the URL and the login page keeps its clean address.
	if (sessionEndReason && sessionEndReason !== SessionEndReason.SIGNED_OUT) {
		params.set(SESSION_END_REASON_PARAM, sessionEndReason);
	}
	const queryString = params.toString();

	return `/auth/login${queryString ? `?${queryString}` : ''}`;
};

export const redirectToLoginPage = (
	redirectUrl?: string,
	sessionEndReason?: SessionEndReason | null
) => {
	window.location.replace(buildLoginPageUrl(redirectUrl, sessionEndReason));
};

export const redirectTo = (url: string) => {
	window.location.href = url;
};

/** Navigates without leaving the current page in history, so Back cannot return to it. */
export const replaceWith = (url: string) => {
	window.location.replace(url);
};
